import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { Quotation } from '../../../../../../shared/types/modules/quotation';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';

export const useDetaileQuotation = (quotation?: Quotation) => {
    const formik = useFormik({
        initialValues: {
            created_at: '',
            createdBy: '',
            updatedBy: '',
            channel: '',
            callId: '',
            typeQuotation: '',
            typification: '',
            subtypification: '',
            bouquet: '',
            body: '',
            template: '',
            status: '',
            observation: '',
            stage: '',
            policyNumber: '',
            policyDate: '',
            motive: '',
            plate: '',
            amount: '',
        },
        onSubmit: console.log,
    });
    const [isDispatch, setIsDispatch] = useState<boolean>(false);
    const [isPending, setIsPending] = useState<boolean>(false);

    useEffect(() => {
        const {
            created_at = '',
            callId: callInfoRaw = '',
            createdBy: createdByRaw = '',
            updatedBy: updatedByRaw = '',
            template = '',
            observation = '',
            body = '',
        } = quotation || {};
        const callInfo =
            typeof callInfoRaw === 'string'
                ? callInfoRaw
                : (callInfoRaw as string) || '';
        const observationData =
            typeof observation === 'string'
                ? observation
                : (observation as string) || '';

        const createdBy =
            createdByRaw && typeof createdByRaw === 'object'
                ? `${createdByRaw.name ?? ''} ${
                    createdByRaw.surname ?? ''
                }`.trim()
                : '';
        const updatedBy =
            createdByRaw && typeof updatedByRaw === 'object'
                ? `${updatedByRaw.name ?? ''} ${
                    updatedByRaw.surname ?? ''
                }`.trim()
                : '';
        const formattedCreatedAt =
            created_at instanceof Date
                ? created_at.toISOString()
                : created_at || '';
        const channelName =
            typeof quotation?.channel === 'object' && quotation?.channel?.name
                ? quotation.channel.name
                : '';
        const bouquetName =
            typeof quotation?.bouquet === 'object' && quotation?.bouquet?.name
                ? quotation.bouquet.name
                : '';
        const statusName =
            typeof quotation?.status === 'object' && quotation?.status?.name
                ? quotation.status.name
                : '';
        const typeQuotationName =
            typeof quotation?.typeQuotation === 'object' &&
            quotation?.typeQuotation?.name
                ? quotation.typeQuotation.name
                : '';
        const typificationName =
            typeof quotation?.typification === 'object' &&
            quotation?.typification?.name
                ? quotation.typification.name
                : '';
        const subtypificationName =
            typeof quotation?.subtypification === 'object' &&
            quotation?.subtypification?.name
                ? quotation?.subtypification.name
                : '';

        const stageName =
            typeof quotation?.stage === 'object' && quotation?.stage?.name
                ? quotation.stage.name
                : '';

        const policyNumber =
            typeof quotation?.policyNumber === 'string'
                ? quotation?.policyNumber
                : '';

        const policyDate =
            quotation?.policyDate instanceof Date
                ? quotation?.policyDate.toISOString()
                : quotation?.policyDate || '';

        const motiveName =
            typeof quotation?.motive === 'object' && quotation?.motive?.name
                ? quotation.motive.name
                : '';

        const plate =
            typeof quotation?.plate === 'string' ? quotation?.plate : '';

        const amount =
            typeof quotation?.amount === 'string' ? quotation?.amount : '';

        formik.setValues({
            created_at: formattedCreatedAt,
            callId: callInfo,
            createdBy,
            updatedBy,
            channel: channelName,
            bouquet: bouquetName,
            typeQuotation: typeQuotationName,
            typification: typificationName,
            subtypification: subtypificationName,
            template: template as string,
            status: statusName,
            observation: observationData,
            body: body,
            stage: stageName,
            policyNumber: policyNumber,
            policyDate: policyDate,
            motive: motiveName,
            plate: plate,
            amount: amount,
        });

        switch ((quotation?.stage as ISelect)?.code) {
            case `${ParamEnum.QUOTATION_STAGES}_EXP`:
                setIsDispatch(true);
                setIsPending(false);
                break;
            case `${ParamEnum.QUOTATION_STAGES}_PEN`:
                setIsPending(true);
                setIsDispatch(false);
                break;
            default:
                setIsDispatch(false);
                setIsPending(false);
                break;
        }
    }, [quotation]);

    return {
        formik,
        isDispatch,
        isPending,
    };
};
